import * as React from 'react';
import type { MapProps } from '../../internal/MapImpl';

const MapImpl = React.lazy(() => import('../../internal/MapImpl'));

/**
 * Lazy loads a map using leaflet.
 */
export const Map: React.FC<MapProps> = (props) => <MapImpl {...props} />;
